mutation updateCompanyAmbassadorSignatureText($input: UpdateCompanyAmbassadorSignatureTextInput!) {
  updateCompanyAmbassadorSignatureText(input: $input)
}
